import { ListOptionType } from '@reducers/listReducer';

export enum ListActionType {
    updateListOptions = '@lists/updateListOptions',
}

interface ActionType {
    type: ListActionType;
}

export interface UpdateListOptionsType extends ActionType {
    payload: {
        listName: string,
        options: ListOptionType,
    };
}


export function updateListOptions(listName: string, options: ListOptionType): UpdateListOptionsType {
    return {
        type: ListActionType.updateListOptions,
        payload: {
            listName,
            options,
        },
    };
}

export type ListAction = UpdateListOptionsType;



// WEBPACK FOOTER //
// ./src/actions/listActions.ts